import React from 'react';
import { cn } from '../../utils/cn';

const Input = React.forwardRef(({ className, type, error, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'input',
        error && 'border-error focus:ring-error',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

Input.displayName = 'Input';

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn('label', className)}
    {...props}
  />
));

Label.displayName = 'Label';

const Textarea = React.forwardRef(({ className, ...props }, ref) => (
  <textarea
    className={cn(
      'input min-h-[80px] resize-none',
      className
    )}
    ref={ref}
    {...props}
  />
));

Textarea.displayName = 'Textarea';

const Select = React.forwardRef(({ className, children, ...props }, ref) => (
  <select
    className={cn(
      'input',
      className
    )}
    ref={ref}
    {...props}
  >
    {children}
  </select>
));

Select.displayName = 'Select';

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <input
    type="checkbox"
    className={cn(
      'h-4 w-4 text-primary border-gray-300 rounded focus:ring-primary',
      className
    )}
    ref={ref}
    {...props}
  />
));

Checkbox.displayName = 'Checkbox';

const Radio = React.forwardRef(({ className, ...props }, ref) => (
  <input
    type="radio"
    className={cn(
      'h-4 w-4 text-primary border-gray-300 focus:ring-primary',
      className
    )}
    ref={ref}
    {...props}
  />
));

Radio.displayName = 'Radio';

export { Input, Label, Textarea, Select, Checkbox, Radio };
